import { render, staticRenderFns } from "./scorePicture.vue?vue&type=template&id=5d93244d&scoped=true&"
import script from "./scorePicture.vue?vue&type=script&lang=js&"
export * from "./scorePicture.vue?vue&type=script&lang=js&"
import style0 from "./scorePicture.vue?vue&type=style&index=0&id=5d93244d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d93244d",
  null
  
)

export default component.exports